import React from 'react';
import PropTypes from 'prop-types';
// import { connect } from 'dva';
import styles from './ContextMenu.module.scss';

/*
  #TODO: Make this more "React-ish", making each context menu item
  a component in itself rather than a simple JSON list.
  -- TJC - March 17, 2020
*/
function ContextMenu(props) {

  return (
    <div className={`${styles.container} ${props.className}`}>
      {props.menuItems.map((menuItem,index) => {
        return (
          <button
            key={index}
            className={styles.menuItem}
            onClick={menuItem.onClick}
          >{menuItem.title}</button>
        );
      })}
    </div>
  );
}

ContextMenu.propTypes = {
  menuItems: PropTypes.array,
  className: PropTypes.string
};

export default ContextMenu;